//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiBetslipSeguroCombinadaNotice',
  props: {
    content: { type: String, default: '' },
    progress: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    showProgress: { type: Boolean, default: true }
  },
  computed: {
    logged_in() {
      return this.user
    }
  }
}
